import React from "react";

function Controller() {
    return (
        <div>
            <h1>Reviews Pod</h1>

            <iframe
                src="https://www.facebook.com/highviewstudios/reviews"
                width="500"
                height="186"
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
                // allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            ></iframe>
        </div>
    );
}

export default Controller;
